import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { inputFields, Spacer, Buttons, tables } from "../../components";

import { UniversityAction } from "../../store/actions";

const TestScores = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const id = location.pathname.split("/")[3];

  const { universityAdmin, isLoading } = useSelector(
    (state) => state?.university
  );

  const [state, setState] = useState({
    testScores: [],
  });

  useEffect(() => {
    setState({
      testScores: universityAdmin?.testScores ?? [],
    });
  }, [universityAdmin]);

  const handleTestScoreChange = (index, field, value) => {
    const updatedTestScores = [...state.testScores];
    updatedTestScores[index][field] = value;
    setState({ ...state, testScores: updatedTestScores });
  };

  const addTestScore = () => {
    const newTestScore = {
      uniID: parseInt(id),
      testName: null,
      score: null,
    };
    setState({ ...state, testScores: [...state.testScores, newTestScore] });
  };

  const removeTestScore = (index) => {
    const updatedTestScores = state.testScores.filter((_, i) => i !== index);
    setState({ ...state, testScores: updatedTestScores });
  };

  const handleSubmit = () => {
    const payload = {
      id: parseInt(id),
      page: "testScores",
      data: state,
    };

    dispatch(
      UniversityAction.editUniversity(payload, () => {
        dispatch(UniversityAction.getUniversityDetailsAdmin(id));
      })
    );
  };

  const columns = [
    {
      title: "#",
      dataIndex: "#",
      width: 40,
      render: (text, record, index) => index + 1,
    },
    {
      title: "Test Name",
      dataIndex: "testName",
      width: 400,
      render: (text, record, index) => (
        <inputFields.DefaultInput
          value={text}
          onChange={(e) =>
            handleTestScoreChange(index, "testName", e.target.value)
          }
        />
      ),
    },
    {
      title: "Score",
      dataIndex: "score",
      width: 450,
      render: (text, record, index) => (
        <inputFields.DefaultInput
          value={text}
          onChange={(e) =>
            handleTestScoreChange(index, "score", e.target.value)
          }
        />
      ),
    },
    {
      title: "Actions",
      width: 80,
      render: (_, record, index) => (
        <div>
          <Buttons.RedButton
            size="medium"
            onClick={() => removeTestScore(index)}
          >
            Remove
          </Buttons.RedButton>
        </div>
      ),
    },
  ];

  return (
    <div className="flex flex-col gap-6">
      <tables.DefaultTable
        dataSource={state.testScores}
        columns={columns}
        rowKey={(record, index) => index}
        pagination={false}
        loading={isLoading}
      />
      <div className="flex gap-5 justify-end">
        <Buttons.DefaultButton onClick={addTestScore} size="medium">
          Add Test Score
        </Buttons.DefaultButton>

        <Buttons.DefaultButton onClick={handleSubmit} size="medium">
          Save Changes
        </Buttons.DefaultButton>
      </div>
      <Spacer height={40} />
    </div>
  );
};

export default TestScores;
